import { NgModule } from '@angular/core'
import {
  CommonModule,
  DatePipe,
  DecimalPipe,
  CurrencyPipe,
} from '@angular/common'
// palmyra-needle-angular-library-import Palmyra will add import angular library module here
import { AccordionModule } from 'primeng/accordion'
import { CardModule } from 'primeng/card'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { ContextMenuModule } from 'primeng/contextmenu'
import { PanelMenuModule } from 'primeng/panelmenu'
import { MenubarModule } from 'primeng/menubar'
import { MessageModule } from 'primeng/message'
import { InputTextareaModule } from 'primeng/inputtextarea'
import { SplitButtonModule } from 'primeng/splitbutton'
import { InputSwitchModule } from 'primeng/inputswitch'
import { SelectButtonModule } from 'primeng/selectbutton'
import { SidebarModule } from 'primeng/sidebar'
import { FieldsetModule } from 'primeng/fieldset'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { MultiSelectModule } from 'primeng/multiselect'
import { PaginatorModule } from 'primeng/paginator'
import { DialogModule } from 'primeng/dialog'
import { DropdownModule } from 'primeng/dropdown'
import { TabViewModule } from 'primeng/tabview'
import { PanelModule } from 'primeng/panel'
import { ToggleButtonModule } from 'primeng/togglebutton'
import { FileUploadModule } from 'primeng/fileupload'
import { PasswordModule } from 'primeng/password'
import { SliderModule } from 'primeng/slider'
import { InputTextModule } from 'primeng/inputtext'
import { InputMaskModule } from 'primeng/inputmask'
import { ButtonModule } from 'primeng/button'
import { CalendarModule } from 'primeng/calendar'
import { KeyFilterModule } from 'primeng/keyfilter'
import { CheckboxModule } from 'primeng/checkbox'
import { RadioButtonModule } from 'primeng/radiobutton'
import { TableModule } from 'primeng/table'
import { ChartModule } from 'primeng/chart'
import { TooltipModule } from 'primeng/tooltip'
import { DataViewModule } from 'primeng/dataview'
import { SlideMenuModule } from 'primeng/slidemenu'
import { PrimengExtensionModule } from '@palmyra/ng-palmyra'
import { ToastModule } from 'primeng/toast'
import { TreeTableModule } from 'primeng/treetable'
import { StepsModule } from 'primeng/steps'

import { PalmyraTemplateDirective } from '@shared/common'
import { DateFormatPipe } from './pipes/date-format.pipe'
import { NumberFormatterDirective } from './directives/number.directive'
import { QuantityFormatterDirective } from './directives/quantite.directive'
import { TwoDigitDecimaNumberDirective } from './directives/twoDigits.directive'
import { ThreeDigitDecimaNumberDirective } from './directives/threeDigits.directive'
import { EightDigitDecimaNumberDirective } from './directives/eightDigits.directive'
import { NumberPipe } from './pipes/number.pipe'
import { QuantiteNumberPipe } from './pipes/quantite-number.pipe'
import { GridPipe } from './pipes/grid.pipe'
import { OperatorPipe } from './pipes/operator.pipe'
import { ArrayFormFilterPipe } from './pipes/filter-arrayform.pipe'
import { CurrencyFormatterDirective } from './directives/currency.directive'
import { ActionPolicyDirective } from './directives/action-policy/action-policy.directive'
import { FieldPolicyDirective } from './directives/field-policy/field-policy.directive'
import { RouterModule } from '@angular/router'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { ProxyRouteComponent } from '@app/shared/components/proxy-route/proxy-route.component'
import { ScreenDialogComponent } from './components/screen-dialog/screen-dialog.component'
import { ValidatorComponent } from './components/validator/validator.component'
import { HideColumnDirective } from './directives/hide-column.directive'
import { CustomSharedModule } from '@app/shared/custom-shared.module'
import { CustomCurrencyPipe } from './pipes/currency.pipe'
import { TranslatorPipe } from './pipes/translator.pipe'
import { DateFormatDirective } from './directives/dateFormat.directive'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { OrderByPipe } from './pipes/orderBy.pipe'
import { LocalService } from './services/local.service'
import { StorageService } from './services/storage.service'
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { BigNumberPipe } from './pipes/big-number.pipe'
import { OrderByUpperCasePipe } from './pipes/orderByUpperCase.pipe'
import { ScrollTopModule } from 'primeng/scrolltop';

/**
 * The share module which exports the commun UI modules and components
 * to be used in the other modules
 *
 * @stable
 */
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    StoreModule,
    EffectsModule,
    DialogModule,
    MessageModule,
    CardModule,
    CustomSharedModule,
    DataViewModule,
    DragDropModule,
    ProgressSpinnerModule,
    ScrollTopModule
  ],
  declarations: [
    PalmyraTemplateDirective,
    DateFormatPipe,
    NumberFormatterDirective,
    QuantityFormatterDirective,
    TwoDigitDecimaNumberDirective,
    ThreeDigitDecimaNumberDirective,
    EightDigitDecimaNumberDirective,
    CurrencyFormatterDirective,
    ActionPolicyDirective,
    FieldPolicyDirective,
    NumberPipe,
    QuantiteNumberPipe,
    OperatorPipe,
    ArrayFormFilterPipe,
    TranslatorPipe,
    CustomCurrencyPipe,
    GridPipe,
    ProxyRouteComponent,
    ScreenDialogComponent,
    ValidatorComponent,
    HideColumnDirective,
    DateFormatDirective,
    OrderByPipe,
    OrderByUpperCasePipe,
    BigNumberPipe
  ],
  exports: [
    CommonModule,
    StoreModule,
    EffectsModule,
    // palmyra-needle-angular-library-export Palmyra will add import angular library module here
    AccordionModule,
    CardModule,
    OverlayPanelModule,
    ContextMenuModule,
    PanelMenuModule,
    MenubarModule,
    MessageModule,
    InputTextareaModule,
    SplitButtonModule,
    InputSwitchModule,
    SelectButtonModule,
    SidebarModule,
    FieldsetModule,
    ConfirmDialogModule,
    AutoCompleteModule,
    MultiSelectModule,
    PaginatorModule,
    DialogModule,
    DropdownModule,
    TabViewModule,
    PanelModule,
    ToggleButtonModule,
    FileUploadModule,
    PasswordModule,
    SliderModule,
    InputTextModule,
    InputMaskModule,
    ButtonModule,
    CalendarModule,
    KeyFilterModule,
    CheckboxModule,
    RadioButtonModule,
    TableModule,
    ChartModule,
    TooltipModule,
    DataViewModule,
    SlideMenuModule,
    PrimengExtensionModule,
    ToastModule,
    TreeTableModule,
    StepsModule,
    OrderByPipe,
    OrderByUpperCasePipe,
    PalmyraTemplateDirective,
    DateFormatPipe,
    NumberPipe,
    QuantiteNumberPipe,
    OperatorPipe,
    TranslatorPipe,
    CurrencyFormatterDirective,
    NumberFormatterDirective,
    QuantityFormatterDirective,
    TwoDigitDecimaNumberDirective,
    ThreeDigitDecimaNumberDirective,
    EightDigitDecimaNumberDirective,
    ActionPolicyDirective,
    FieldPolicyDirective,
    GridPipe,
    ArrayFormFilterPipe,
    CustomCurrencyPipe,
    SlideMenuModule,
    ProxyRouteComponent,
    ScreenDialogComponent,
    ValidatorComponent,
    HideColumnDirective,
    CardModule,
    CustomSharedModule,
    DateFormatDirective,
    DataViewModule,
    DragDropModule,
    ProgressSpinnerModule,
    BigNumberPipe
  ],
  providers: [
    DatePipe,
    NumberPipe,
    QuantiteNumberPipe,
    TranslatorPipe,
    CustomCurrencyPipe,
    CurrencyPipe,
    GridPipe,
    DecimalPipe,
    StorageService,
    LocalService,
    BigNumberPipe
  ],
})
export class SharedModule {}
